import React, { useState } from "react";

import { useNavigate } from "react-router-dom";

import imageOne from "../../resource/hermitage/ongoing-projects/2.png";
import imageThree from "../../resource/hermitage/ongoing-projects/1.png";

import tableImage from "../../resource/hermitage/ongoing-projects/5.png";

import imageFour1 from "../../resource/hermitage/ongoing-projects/3.png";
import imageFive1 from "../../resource/hermitage/ongoing-projects/4.png";
import imageSix from "../../resource/hermitage/ongoing-projects/6 (1).png";

import { Carousel } from "../Corousel/Carousel";

import data from "../../data/carouselData.json";
const OngoingProjects = () => {
  const navigate = useNavigate();
  const handleClick = (event) => {
    const pathMap = {
      onGoingRequest: "/onGoingRequest",
    };

    const path = event.currentTarget.id;
    const targetPath = pathMap[path];

    if (targetPath) {
      navigate(targetPath);
    }
  };

  const materials = [
    { name: "Total Cost for Project 02", cost: "$100,000" },
    { name: "Cost per meter", cost: "$1000" },
    { name: "Electricity and Plumbing  ", cost: "$20,000" },

  ];

  return (
    <div className="ongoingProject-page inside-pages">
      <div className="right-box">
        <img
          src={imageOne}
          alt="Right Top Image"
          className="right-image"
          width={300}
        />
      </div>

      <h1 className="font-main dark-gold p-4 mt-4">
        Ongoing Building Projects
      </h1>
      <p className="h4 dark-gold p-4 mt-4">
        The ongoing building projects at the Bhaddeka Vihari Monastery and
        Meditation Centre are set to bring considerable developments that will
        greatly enhance the facilities and experience of all who use the
        monastery.
      </p>
      <h1 className="font-main dark-gold p-4 mt-6 text-center">Project 01</h1>
      <p className="h4 dark-gold p-4 mt-6 text-bold">
        Construction of a new building complex
      </p>

      <p className="mt-5 h4 mb-4 p-4">
        The major ongoing project is constructing of a new building complex.
        This complex will consist of 12 kutis, each designed with necessary
        facilities to enhance comfort and accessibility to the residents.
        Notably, 2 of these kutis will be equipped with additional amenities to
        accommodate individuals with disabilities.
      </p>

      <p className="mt-5 h4 mb-4 p-4">
        The estimated cost to construct each kuti in this complex is $35,000.
        This expansion not only aims to enhance the comfort of seasoned devotees
        but also warmly invites newcomers into our spiritual community.
      </p>
      <p className="mt-5 h4 mb-4 p-4">
        We invite you to participate in this meritorious endeavor by sponsoring
        a kuti at the contribution level of $35,000. Alternatively, you can join
        as a group and make payments in installments according to the following
        schedule:
      </p>
      <div className="p-4 text-center mt-6">
        <img src={tableImage} alt="image" width={600} className="tableimage" />
      </div>

      <h1 className="font-main dark-gold p-4 mt-6 text-center">
        Project 01 - Photos
      </h1>
      <div className=" mt-6 p-4 center">
        <div className=" mt-6">
          <Carousel data={data.ongoingB} />
        </div>
      </div>

      <p className="h4 mt-6 p-4">
        By contributing, you will be playing a vital role in expanding our
        facilities and enhancing the experience for all who seek refuge within
        the monastery.
      </p>
      <p className="h4 mt-5 p-4">
        If you would like to participate in this worthy cause or require further
        information, please contact the Bhaddeka Vihari Monastery and Retreat
        Centre office
      </p>

      <h1 className="font-main dark-gold p-4 mt-6 text-center">Project 02</h1>
      <p className="h4 dark-gold p-4 mt-6 text-bold">
        Construction of a Road and Car Park
      </p>

      <p className="mt-5 h4 mb-4 p-4">
        An important project of constructing a car park and carpet paths leading
        from the main road to all cottages is now commencing. This project will
        also incorporate a rainwater drainage system, ensuring effective water
        management on the premises. The car park will provide approximately 50
        designated parking spots for our community.
      </p>

      <p className="mt-5 h4 mb-4 p-4">
        Bhaddeka Vihari Monastery and Retreat Centre warmly welcomes volunteers,
        individuals or groups to assist with this essential construction work.
        Whether by providing physical labor or support tailored to your skills
        and capabilities, your contributions will make a significant impact on
        the growing community use this premises.
      </p>
      <p className="mt-5 h4 mb-4 p-4">
        This new facility is designed to enhance the comfort and accessibility
        for those participating in various programs and activities at the
        monastery.
      </p>
      <p className="mt-4 h4 mb-4 p-4">
        For those who wish to contribute monetarily to support the ongoing
        construction, your generous donations will help us purchase necessary
        materials and items required to complete this project.
      </p>
      <h1 className="font-main dark-gold p-4 mt-6 text-center">
        Project 02 - Photos
      </h1>

      <div className=" mt-6 p-4 center">
        <div className=" mt-6">
          <Carousel data={data.ongoingP} />
        </div>
      </div>

      <h1 className="font-second dark-gold p-4 mt-6 ">
        Materials Needed for the Road and Car Park Construction
      </h1>

      <div className="table-container h4 mt-5 p-4">
        <table>
          <thead>
            <tr>
              <th>Materials Needed</th>
              <th>Cost</th>
            </tr>
          </thead>
          <tbody>
            {materials.map((item, index) => (
              <tr key={index}>
                <td>{item.name}</td>
                <td>{item.cost}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <h1 className="font-main dark-gold p-4 mt-6 text-center">Project 03</h1>
      <p className="h4 dark-gold p-4 mt-6 text-bold">
        Creating a Walking Path Around the Premises
      </p>

      <h1 className="font-main dark-gold p-4 mt-6 text-center">
        Project 03 - Photos
      </h1>
      <div className=" mt-6 p-4 center">
        <div className=" mt-6">
          <Carousel data={data.ongoingW} />
        </div>
      </div>

      <p className="h4 mt-5 p-4">
        A walking path will be constructed around the boundary of the Monastery
        to encourage residents to connect with nature while promoting their
        physical well-being. This path will be available for both the Sangha and
        lay community to engage in walking meditation, surrounded by lush
        greenery. Additionally, the path will serve as an emergency exit in the
        event of a bushfire or other urgent situations, including medical
        emergencies, ensuring the safety and well-being of all individuals on
        the premises
      </p>

      <h1 className="font-second dark-gold p-4 mt-6 ">
      Materials Needed for Path Construction
      </h1>

      <div className="table-container2 h4 mt-5 p-4">
        <table>
          <thead>
            <tr>
              <th>Materials Needed</th>
              <th>Cost</th>
            </tr>
          </thead>
          <tbody>
            {materials.map((item, index) => (
              <tr key={index}>
                <td>{item.name}</td>
                <td>{item.cost}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <h1 className="font-main dark-gold p-4 mt-6 ">Materials Needed for Construction on Common Public Spaces</h1>
      <p className="h4 mt-5 p-4">
      Apart from the aforementioned major projects, several smaller initiatives are planned to develop public areas within the monastery premises, with the aim of enhancing the community's wellbeing and comfort. These projects will contribute to the overall development of the monastery, ensuring that all necessary amenities are available for those who seek peace and spiritual growth.  
      </p>
      <p className="h4 mt-5 p-4">
      If you wish to donate materials or supplies, please inform the Bhaddeka Vihari Monastery and Meditation Centre office. For your convenience, we have provide a list of necessary materials on the following table below.
      </p>
      
      <h1 className="font-second dark-gold p-4 mt-6 text-center ">
      Materials Needed
      </h1>

      <div className="table-container2 h4 mt-5 p-4 ">
        <table >
         
          <tbody>
            <tr>
                <td>3 Paint Tins</td>
                
              </tr>
              <tr>
              <td>5 Steel Bars (12’ * 2’)	</td>
              </tr>
              <tr>
                <td>1 Wheelbarrow</td>
              </tr>
              <tr>
                <td>1 Door</td>
              </tr>
           
          </tbody>
        </table>
      </div>


      <div className="btn-group2 mt-6">
        <img src={imageFour1} alt="Right Top Image" width={300} />
        <img src={imageFive1} alt="Right Top Image" width={300} />
      </div>

      
  

      <div className="p-4 mt-6 text-center">
        <div className="mt-6 calander-box align-item-center">
          <div className="c-details text-left">
            <h2 className="intro-text ">Futher More Details : </h2>
            <p className="font-p mt-4">
              Monastery : 035608 0918 / 0459 729 738
            </p>
            <p className="font-p">Mr Gamini : 0422 069 359</p>
            <p className="font-p">WhatsApp : 0422 069 359</p>
            <p className="font-p">E-mail : info@bvp.org.au</p>
          </div>

          <div className="d-button">
            <img
              src={imageSix}
              alt="Right Top Image"
              width={300}
              className="right-image curser-pointer"
              id="onGoingRequest"
              onClick={handleClick}
            />
          </div>
        </div>
      </div>

      <div className="bottom-box mt-6">
        <img src={imageThree} alt="bottom-image" width={600} />
      </div>
    </div>
  );
};

export default OngoingProjects;
